var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"blulog"}},[_c('v-main',{staticClass:"c-body"},[_c('transition',{attrs:{"name":"default-page-fade","mode":"out-in"}},[_c('nuxt')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }